import 'normalize.css/normalize.css';
import './monaco-editor-hack';
import React from 'react';
import ReactDOM from 'react-dom';
import { GreyCat } from '@greycat/core';
import Studio from './Studio';
import StudioStore from './stores/StudioStore';
import storage from './storage';
import reactions from './reactions';
import './index.css';
const root = document.getElementById('root');
const errorTimeout = setTimeout(() => {
    root.innerHTML = '<p class="alert alert-danger">Something went wrong while initializing GreyCat Studio. Sorry :/</p>';
}, 10000);
GreyCat.onReady(() => {
    clearTimeout(errorTimeout);
    // initialize stores
    const store = new StudioStore();
    // load store with state from storage
    storage.load(store)
        .then(() => {
        // register reactions
        reactions.configure(store);
        // render app
        ReactDOM.render(React.createElement(Studio, { store: store }), root);
    }, (err) => {
        root.innerHTML = `<p class="alert alert-danger">Unable to load state from storage. ${err.message}</p>`;
    });
});
